const loadDependency = (url, id, callback) => {
	const script = document.createElement('script');
	script.id = id;
	script.src = url;
	script.async = true;
	script.onload = callback;
	document.head.appendChild(script);
};

const removeDependency = id => {
	const targetElem = document.getElementById(id);
	if (targetElem) targetElem.remove();
};

export { loadDependency, removeDependency };
